import {
  filterFieldCatalogue,
  filterOperatorCatalogue,
  SearchFilter,
  type SearchFilterItem,
} from 'lib-search-ui';
import { memo } from 'react';

import { filterItems } from '../../../../utils/definitions';
import { useSearchQuickFilter } from '../../utils/useSearchQuickFilter';

const items: readonly SearchFilterItem[] = filterItems.initial_direction.map(
  ({ id, name }) => ({ value: `${id}`, label: `${name}` }),
);

export const SearchDirectionQuickFilter = memo(
  function SearchDirectionQuickFilter(): JSX.Element {
    const { condition, handleChange } =
      useSearchQuickFilter('initial_direction');

    return (
      <SearchFilter
        items={items}
        defaultOperator={
          filterOperatorCatalogue.conversations.initial_direction
            .defaultOperator
        }
        selectedValues={condition?.values}
        selectedOperator={condition?.operator}
        onChange={handleChange}
        showSearch={false}
      >
        {filterFieldCatalogue.conversations.initial_direction.label}
      </SearchFilter>
    );
  },
);
